function escapeHtml(value) {
    return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}

function readTag(src, index) {
    if (src.startsWith("{{{", index)) {
        const end = src.indexOf("}}}", index + 3);
        if (end < 0) return null;
        return { raw: true, kind: "", name: src.slice(index + 3, end).trim(), next: end + 3 };
    }
    if (!src.startsWith("{{", index)) return null;
    const end = src.indexOf("}}", index + 2);
    if (end < 0) return null;
    const inner = src.slice(index + 2, end).trim();
    const kind = inner[0];
    if (kind === "#" || kind === "^" || kind === "/" || kind === "!") {
        return { raw: false, kind, name: inner.slice(1).trim(), next: end + 2 };
    }
    return { raw: false, kind: "", name: inner, next: end + 2 };
}

function findClose(src, from, name) {
    let depth = 1;
    let index = from;
    while (index < src.length) {
        const at = src.indexOf("{{", index);
        if (at < 0) return null;
        const tag = readTag(src, at);
        if (!tag) return null;
        if (tag.kind === "#" || tag.kind === "^") depth += 1;
        if (tag.kind === "/") {
            depth -= 1;
            if (depth === 0 && tag.name === name) return { start: at, next: tag.next };
        }
        index = tag.next;
    }
    return null;
}

function lookup(stack, name) {
    if (name === ".") return stack[stack.length - 1];
    const parts = name.split(".");
    for (let level = stack.length - 1; level >= 0; level -= 1) {
        let current = stack[level];
        let found = true;
        for (const part of parts) {
            if (current == null || typeof current !== "object" || !(part in current)) {
                found = false;
                break;
            }
            current = current[part];
        }
        if (found) return current;
    }
    return undefined;
}

function isTruthy(value) {
    if (Array.isArray(value)) return value.length > 0;
    return Boolean(value);
}

function renderRange(src, start, end, stack) {
    let html = "";
    let index = start;
    while (index < end) {
        const tagAt = src.indexOf("{{", index);
        if (tagAt < 0 || tagAt >= end) {
            html += src.slice(index, end);
            break;
        }
        html += src.slice(index, tagAt);
        const tag = readTag(src, tagAt);
        if (!tag || tag.next > end) {
            html += src.slice(tagAt, end);
            break;
        }
        if (tag.kind === "!") {
            index = tag.next;
            continue;
        }
        if (tag.kind === "#" || tag.kind === "^") {
            const close = findClose(src, tag.next, tag.name);
            if (!close || close.start > end) {
                index = tag.next;
                continue;
            }
            const value = lookup(stack, tag.name);
            const show = tag.kind === "#" ? isTruthy(value) : !isTruthy(value);
            if (show) {
                if (tag.kind === "#" && Array.isArray(value)) {
                    for (const item of value) {
                        html += renderRange(src, tag.next, close.start, [...stack, item]);
                    }
                } else if (tag.kind === "#" && value && typeof value === "object") {
                    html += renderRange(src, tag.next, close.start, [...stack, value]);
                } else {
                    html += renderRange(src, tag.next, close.start, stack);
                }
            }
            index = close.next;
            continue;
        }
        if (tag.kind === "/") {
            index = tag.next;
            continue;
        }
        const value = lookup(stack, tag.name);
        const text = value == null ? "" : String(value);
        html += tag.raw ? text : escapeHtml(text);
        index = tag.next;
    }
    return html;
}

export function renderMustache(template, view) {
    return renderRange(String(template || ""), 0, String(template || "").length, [view]);
}
